module.exports = __webpack_public_path__ + "static/media/manhua1.d79afae3.png";